<template>
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0911 5.9987C13.0911 6.96537 12.8045 7.85204 12.3111 8.59204C11.5911 9.65871 10.4511 10.4121 9.12448 10.6054C8.89781 10.6454 8.66448 10.6654 8.42448 10.6654C8.18448 10.6654 7.95115 10.6454 7.72448 10.6054C6.39781 10.4121 5.25781 9.65871 4.53781 8.59204C4.04448 7.85204 3.75781 6.96537 3.75781 5.9987C3.75781 3.4187 5.84448 1.33203 8.42448 1.33203C11.0045 1.33203 13.0911 3.4187 13.0911 5.9987Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5892 12.3149L13.4892 12.5749C13.2426 12.6349 13.0492 12.8216 12.9959 13.0683L12.7626 14.0483C12.6359 14.5816 11.9559 14.7416 11.6026 14.3216L8.42258 10.6683L5.24258 14.3283C4.88925 14.7483 4.20925 14.5883 4.08258 14.0549L3.84925 13.0749C3.78925 12.8283 3.59591 12.6349 3.35591 12.5816L2.25591 12.3216C1.74925 12.2016 1.56925 11.5683 1.93591 11.2016L4.53591 8.60156C5.25591 9.66823 6.39591 10.4216 7.72258 10.615C7.94925 10.655 8.18258 10.675 8.42258 10.675C8.66258 10.675 8.89591 10.655 9.12258 10.615C10.4492 10.4216 11.5892 9.66823 12.3092 8.60156L14.9092 11.2016C15.2759 11.5616 15.0959 12.1949 14.5892 12.3149Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.80722 3.98797L9.20055 4.77463C9.25389 4.88129 9.39389 4.98796 9.52055 5.00796L10.2339 5.12796C10.6872 5.20129 10.7939 5.53463 10.4672 5.8613L9.91389 6.41462C9.82055 6.50795 9.76722 6.68797 9.80055 6.8213L9.96055 7.50796C10.0872 8.04796 9.80055 8.26129 9.32055 7.97462L8.65389 7.58129C8.53389 7.50795 8.33389 7.50795 8.21389 7.58129L7.54722 7.97462C7.06722 8.25462 6.78055 8.04796 6.90722 7.50796L7.06722 6.8213C7.09389 6.69463 7.04722 6.50795 6.95389 6.41462L6.40056 5.8613C6.07389 5.53463 6.18055 5.20796 6.63389 5.12796L7.34722 5.00796C7.46722 4.98796 7.60722 4.88129 7.66055 4.77463L8.05389 3.98797C8.24722 3.5613 8.59389 3.5613 8.80722 3.98797Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  color: {
    type: String,
    default: "black",
  },
});
</script>
